import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { forwardRef as d } from "react";
const a = ({ children: o, ...e }, l) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 32 32",
    ref: l,
    ...e,
    children: [
      o,
      /* @__PURE__ */ r(
        "path",
        {
          fillRule: "evenodd",
          d: "M29.406 10.587a2 2 0 0 0-2.83 0l-10.58 10.58-10.58-10.58a2.001 2.001 0 1 0-2.83 2.83l12 12a2 2 0 0 0 2.83 0l12-12a2 2 0 0 0-.01-2.83",
          clipRule: "evenodd"
        }
      )
    ]
  }
), i = d(a);
i.displayName = "IconChevronDownFilled";
export {
  i as IconChevronDownFilled
};
//# sourceMappingURL=IconChevronDownFilled.js.map
